import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/c')({
  component: () => null,
  beforeLoad: () => {
    throw redirect({
      to: '/login',
      search: { method: 'sms', redirect: '/client' }
    });
  }
});
